import {FC} from 'react'
import {Redirect, useHistory, useLocation, useParams} from 'react-router-dom'
import queryString from 'query-string'
import {useQuery} from 'hooks/graphql'
import {useSelector} from 'hooks/redux'
import {Presenter} from './Presenter'
import {EMPLOYEE_DOCUMENTS, QueryResult, QueryVariables} from './query'
import {getSavedDisplayTypeLimit, saveDisplayTypeLimit} from './utils'

export const Create: FC = () => {
  const {id} = useParams<{id: string}>()
  const history = useHistory()
  const {search, pathname} = useLocation()
  const user = useSelector((state) => state.session.currentUser)
  const query = queryString.parse(search, {arrayFormat: 'bracket'}) as {documentIds: string[]; page: string}
  const page = Number(query.page) || 1
  const per = Number(getSavedDisplayTypeLimit(pathname, user))

  const {data, loading} = useQuery<QueryResult, QueryVariables>(EMPLOYEE_DOCUMENTS, {
    fetchPolicy: 'network-only',
    variables: {
      id,
      documentIds: query.documentIds,
      per,
      page,
    },
    skip: !query.documentIds,
  })

  const setPage = (page: number) => {
    const newQuery = {...query, page: page}
    history.push({pathname, search: queryString.stringify(newQuery, {arrayFormat: 'bracket'})})
  }

  const setPerPage = (per: number) => {
    saveDisplayTypeLimit(pathname, user, per)
    setPage(1)
  }

  const client = data?.client
  const employee = client?.employee

  if (client && employee) {
    const isAllowedSendContract = client.planType === 'paid_plan' && client.isVerified
    if (!isAllowedSendContract || employee.documents.list.length === 0) {
      return <Redirect to={`/documents/employees/${id}`} />
    }
  }

  return (
    <Presenter
      employee={employee}
      documentIds={query.documentIds ?? []}
      documents={employee?.documents}
      loading={loading}
      per={per}
      page={page}
      setPage={setPage}
      setPerPage={setPerPage}
    />
  )
}
